import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs/internal/Subject';
import { first, takeUntil } from 'rxjs/operators/index';
import { CommonService } from '../../../../app/common/services/common.service';
import { GlobalConstants } from '../../../../app/common/constants/global.constant';
import { DataService } from '../../../../app/core/data/data-service';
import { BannerCarouselService } from '../../../../app/core/routing/services/asset-library/banner-carousel.service';
import { BannerContent, BannerContentConfiguration, BannerContentGroupPage, BannerContentViewModel, CreateBannerContentResponse } from '../banner-carousel/interface/banner-carousel.i';
import { CreateBannerViewModel, BannerPreview } from './interface/create-banner-carousel.i';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Utils } from '../../../common/utils/utils';
import { FormFactor } from '../form-factors/interfaces/form-factors.i';
import { User } from '../../account/login/_models/user.model';
import { AppGlobal } from '../../../core/state/app-global';
import { AssetLibraryConstants } from '../../../core/routing/services/asset-library/constants/asset-library.constant';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'iposcen-create-banner-carousel',
  templateUrl: './create-banner-carousel.component.html',
  styleUrls: ['./create-banner-carousel.component.scss']
})
export class CreateBannerCarouselComponent implements OnInit, OnDestroy {
  @Input() pageNumber: number;
  @Input() contentGroupType: string;
  @Input() bannerFunction: string;
  @Input() bannerContentDetails: BannerContentViewModel;
  @Output() readonly goBacktoBannerContent = new EventEmitter<object>();
  @Output("refreshBannerContentdata") refreshBannerContentdata = new EventEmitter();
  @ViewChild('imageInput', { static: false }) imageInput: ElementRef;
  @ViewChild('formFactorsModal') formFactorsModal: ElementRef;
  @ViewChild('deleteModal') deleteModal: ElementRef;
  @ViewChild('deleteStoreLogoModal') deleteStoreLogoModal: ElementRef;
  @Input() presentpage;
  bannerContentgrpForm: FormGroup;
  isPublishedDateInCorrect: boolean;
  bannerDeleteButton: string;
  isExpiredDateIncorrect: boolean;
  defaultImages: CreateBannerViewModel[];
  otherImages: CreateBannerViewModel[];
  bannerCarousel: CreateBannerViewModel[];
  bannerToDelete: string;
  bannerToDeleteName: string;
  isSubmitted: boolean;
  isFormValid: boolean;
  isImage: boolean;
  file: any;
  imageDoc: any;
  imageUrl: any = '';
  imageSizeError: any;
  imageLengthError: any;
  imageTypeError: any;
  imageFormat: string;
  imageFileType: string;
  imageFileName: string;
  imageFileSize: number;
  isImageAvailable = false;
  isImageFormat: boolean;
  bannerContentConfiguration: BannerContentConfiguration;
  bannerCGToDeleteName: string;
  isPublished: boolean;
  selectedBannerContentId: string;
  selectedContentGroupID: string;
  selectedFormFactors: FormFactor;
  selectedBannerContent: BannerContentViewModel;
  otherbannerContent: BannerContentViewModel[];
  bannerCarouselImages: CreateBannerViewModel[];
  bannerContent: BannerContent;
  bannnerContentGroupPages: BannerContentGroupPage;
  media = {} as any;
  userId = sessionStorage.getItem('userId');
  url: string;
  currentDetailPage: string;
  createdBannerContentId: string;
  bannerPreviewData: BannerPreview;
  isRemoveEnabled: boolean;
  deviceTypes = GlobalConstants.DEVICE_TYPES;
  manufacturers = GlobalConstants.MANUFACTURERS;
  processors = GlobalConstants.PROCESSORS;
  generation = GlobalConstants.GENERATION;
  isImgVideoSizeInfoEnabled: boolean;
  publishedNamePlaceholderText = AssetLibraryConstants.PUBLISHED_NAME_PLACEHOLDER;
  internalNamePlaceholderText = AssetLibraryConstants.INTERNAL_NAME_PLACEHOLDER;
  envurl = AssetLibraryConstants.S3_ASSET_LIBRARY_USERS + this.userId
    + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId
    + AssetLibraryConstants.BANNER_CONTENTS + AssetLibraryConstants.SLASH;
  userRole:string;
  retailerConfig:any;  

  isPublishDateCustomDatepicker: boolean;
  customPublishDateResult: string;
  isCustomPublishDateCorrect: boolean;
  isCustomExpiryDateCorrect: boolean;
  editPublishDateInfo: string;
  customExpiryDateResult: string;
  editExpiryDateInfo: string;
  isExpiryDatePicker: boolean;
  divideDateFormat: boolean = true;
  isCustomPublishTimeZoneSelected = false;
  isCustomExpiryTimeZoneSelected = false;
  retailerId: string;
  bgColor: string;
  private ngUnsubscribe = new Subject<boolean>();

  constructor(
    private formBuilder: FormBuilder,
    private bannerContentService: BannerCarouselService,
    private cmnSer: CommonService,
    private dataService: DataService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private appGlobal: AppGlobal,
  ) { }

  ngOnInit(): void {
    this.customPublishDateResult = GlobalConstants.NOW;
    this.customExpiryDateResult = GlobalConstants.NEVER;
    this.isExpiredDateIncorrect = false;
    this.retailerId = sessionStorage.getItem('retailerId');
    this.appGlobal.$userAccount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (userAccount: User) => {
        this.isRemoveEnabled = userAccount.isRemoveEnabled;
        this.userRole = userAccount.role;
        if(this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ){
          this.retailerConfig = (userAccount.configurations !== undefined) ? JSON.parse(userAccount.configurations) : await this.cmnSer.getRetailerConfig(this.userId,this.retailerId);
        }
      });
    this.bannerPreviewData = {
      image: {
        name: '',
        url: '',
        format: ''
      },
      bgColor: '#000000'
    }
    this.dataService.getBannerContent()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((selectedBannerContentToEdit: any) => {
        this.isImgVideoSizeInfoEnabled = this.cmnSer.isSizeContraintsEnabled;
        if (selectedBannerContentToEdit) {
          this.bannerContentService.buttonName = GlobalConstants.SAVE_CHANGES;
          this.isImageFormat = true;
          this.selectedBannerContent = selectedBannerContentToEdit;
          this.selectedBannerContentId = selectedBannerContentToEdit.id;
          this.isImageAvailable = (this.selectedBannerContent.configurations.imageFile !== '');
          this.imageFileName = this.isImageAvailable ? this.selectedBannerContent.configurations.imageFile : '';
          this.imageUrl = this.bannerPreviewData.image.url = environment.apiBaseUrlAsset + this.envurl + this.selectedBannerContentId;
          this.cmnSer.uploadedImageURL = this.imageUrl;
          this.cmnSer.emitDataToLivePreview({ page: GlobalConstants.BANNER, dataSet: this.bannerPreviewData });
          this.selectedFormFactors = this.selectedBannerContent.configurations.formFactor;
          if((this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) && !this.retailerConfig?.bcNonIntelDeviceEnabled) {
            if(this.selectedFormFactors.allDevices){
              this.selectedFormFactors.allDevices = false;
              this.selectedFormFactors.processors = GlobalConstants.PROCESSORS_EXCEPT_INTEL;
            }
          } // when bcNonIntelDeviceEnabled switched from true to false

          if (selectedBannerContentToEdit.configurations.isPublishDateNow) {
            this.isPublishDateCustomDatepicker = false;
            this.editPublishDateInfo = GlobalConstants.NOW;
          } else {
            if(selectedBannerContentToEdit.configurations.publishTime) {
              this.isPublishDateCustomDatepicker = true;
              this.customPublishDateResult = selectedBannerContentToEdit.configurations.publishTime;
              this.editPublishDateInfo = selectedBannerContentToEdit?.configurations?.publishTime;
            } 
          }
          if (selectedBannerContentToEdit.configurations.isPublishExpiryNever) {
            this.isExpiryDatePicker = false;
            this.editExpiryDateInfo = GlobalConstants.NEVER;
          } else {
            if(selectedBannerContentToEdit.configurations.expireTime) {
              this.isExpiryDatePicker = true;
              this.customExpiryDateResult = selectedBannerContentToEdit.configurations.expireTime;
              this.editExpiryDateInfo = selectedBannerContentToEdit.configurations.expireTime;
            }
          }

        } else {
          this.bannerContentService.buttonName = GlobalConstants.SAVE_AND_PROCEED;
          //if flag is false 
          let proceArr = GlobalConstants.ALL;
          if((this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole ===GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) && !this.retailerConfig?.bcNonIntelDeviceEnabled){
            proceArr = GlobalConstants.PROCESSORS_EXCEPT_INTEL;
          }
          this.selectedFormFactors = {
            allDevices: ((this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) && !this.retailerConfig?.bcNonIntelDeviceEnabled)?false : true,
            devices: GlobalConstants.ALL,
            manufacturer: GlobalConstants.ALL,
            processors:  proceArr,
            generations: GlobalConstants.ALL
          };
        }
      });

    this.isSubmitted = false;
    this.isPublished = this.getPublishName();
    this.createBannerContentGroupForm();
    this.media = {
      url: '',
      name: '',
      format: '',
      uploadedDate: ''
    };
    this.cmnSer.getRetailGifValue
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(data => {
      if (data === true) {
        this.cmnSer.setSwitchstatus(true);
      }
    });
    this.cmnSer.setPresentPageValue(this.presentpage);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  createBannerContentGroupForm() {
    // TODO -- need to add validations for form fields
    this.bannerDeleteButton = GlobalConstants.BANNER;
    this.bannerContentgrpForm = this.formBuilder.group({
      publishedName: new FormControl((this.selectedBannerContent) ? this.selectedBannerContent.configurations.publishedName : '',
        [Validators.required, Validators.maxLength(50)]),
      internalName: new FormControl((this.selectedBannerContent) ? this.selectedBannerContent.configurations.internalName : ''),
      imageFile: new FormControl('')
    });
    this.bgColor= (this.selectedBannerContent && this.selectedBannerContent.configurations?.bgColor) ? this.selectedBannerContent.configurations?.bgColor :'#000000';
    this.cmnSer.emitDataToLivePreview({ page: GlobalConstants.BANNER, dataSet: {bgColor : this.bgColor} });
  }

  trackByConfiguration(index: number, el: string): number {
    return index;
  }

  trackByCreateBanner(index: number, el: string): number {
    return index;
  }

  getPublishName(): boolean {
    return this.isSubmitted && this.bannerContentgrpForm?.controls?.publishedName?.value.trim() === '';
  }

  openDeleteModalBC() {
    this.imageUrl = '';
    this.media.uploadedDate = '';
    this.imageFileName = '';
    this.imageDoc = [];
    this.isImageAvailable = false;
    this.emitImageDataToPreview(this.imageDoc)
  }

  getBannerConfigObject(bannerFactor: FormFactor) {

    return {
      publishedName: this.bannerContentgrpForm.controls.publishedName.value.trim(),
      internalName: this.bannerContentgrpForm.controls.internalName.value,
      imageFile: (this.imageDoc) ? this.imageDoc[0].name : this.imageFileName,
      publishTime: (this.customPublishDateResult.toString() !== GlobalConstants.NOW) ?
      this.customPublishDateResult.toString() : Utils.getCurrentDate(),
      expireTime: (this.customExpiryDateResult.toString() !== GlobalConstants.NEVER) ?
      this.customExpiryDateResult.toString() : GlobalConstants.NEVER,
      type: GlobalConstants.BANNER_CONTENT_GROUP,
      contentGroupPages: this.selectedBannerContent?.configurations?.contentGroupPages ? this.selectedBannerContent?.configurations?.contentGroupPages : [],
      customURL: this.selectedBannerContent?.configurations?.customURL,
      formFactor: bannerFactor,
      isPublishDateNow: !this.isPublishDateCustomDatepicker,
      isPublishExpiryNever: !this.isExpiryDatePicker,
      bgColor: this.bgColor
    }; 
  }

  createBannerContent() {
    const bannerFactor: FormFactor = Utils.getFormFactorValues(this.selectedFormFactors);
    const bannerContentConfig: BannerContentConfiguration = this.getBannerConfigObject(bannerFactor);
    if (bannerContentConfig.expireTime !== GlobalConstants.NEVER) {
      bannerContentConfig.expireTime = Utils.changeSaveDateFormat(bannerContentConfig.expireTime);
    }
    if (!bannerContentConfig.isPublishDateNow) {
      bannerContentConfig.publishTime = Utils.changeSaveDateFormat(bannerContentConfig.publishTime);
    }
    this.bannerContentService.createBannerContent(JSON.stringify(bannerContentConfig))
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(createBannerCarouselResponse => {
        const createBannerCarouselResponseObj: CreateBannerContentResponse = createBannerCarouselResponse as CreateBannerContentResponse;
        this.bannerContentService.uploadImage(this.imageDoc[0], createBannerCarouselResponse.bannerCarousel.id,
          (this.imageDoc === !this.imageDoc) ? '' : this.imageDoc[0].name.split('.')
            .pop())
          .pipe(takeUntil(this.ngUnsubscribe))
          .pipe(first())
          .subscribe(() => {
            this.goBacktoBannerContent.emit(createBannerCarouselResponseObj);
            this.cmnSer.emitMetadataCheck(true, this.bannerFunction);
            //Code create profile banner content       
            this.createdBannerContentId = createBannerCarouselResponse.bannerCarousel.id;
            this.currentDetailPage = this.router.url;
            const pageName = this.currentDetailPage.lastIndexOf('/');
            //Checking if Current page URL is create profile
            if (this.currentDetailPage.substring(pageName + 1) === GlobalConstants.CREATE_PROFILE) {
              //using commonservice to pass BannerContent id to create profile page
              this.cmnSer.emitBannerContentId(this.createdBannerContentId);
            }
          },
            error => {
              // do something
            });
      },
        error => {

        });

  }

  updateBannerContent() {
    const bannerCarousel = this.selectedBannerContent as unknown as BannerContent;
    const bannerFactor: FormFactor = Utils.getFormFactorValues(this.selectedFormFactors);
    const bannerContentConfig: BannerContentConfiguration = this.getBannerConfigObject(bannerFactor);
   if (bannerContentConfig.expireTime !== GlobalConstants.NEVER) {
      bannerContentConfig.expireTime = Utils.changeSaveDateFormat(bannerContentConfig.expireTime);
    }
    if (!bannerContentConfig.isPublishDateNow) {
      bannerContentConfig.publishTime = Utils.changeSaveDateFormat(bannerContentConfig.publishTime);
    }
    bannerCarousel.configurations = JSON.stringify(bannerContentConfig);
    this.bannerContentService.putBannerContentById(JSON.stringify(bannerCarousel), this.selectedBannerContentId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(updateBannerCarouselResponse => {

        const createBannerCarouselResponseObj: CreateBannerContentResponse = updateBannerCarouselResponse as CreateBannerContentResponse;
        const bannerCarouselImageViewModel: CreateBannerViewModel = updateBannerCarouselResponse.bannerCarousel as CreateBannerViewModel;
        if (this.imageDoc) {
          this.bannerContentService.uploadImage(this.imageDoc[0], updateBannerCarouselResponse.bannerCarousel.id,
            this.imageDoc[0].name.split('.')
              .pop())
            .pipe(takeUntil(this.ngUnsubscribe))
            .pipe(first())
            .subscribe(() => {
              this.cmnSer.emitMetadataCheck(true, this.bannerFunction);
              this.bannerCarouselImages = [];
              bannerCarouselImageViewModel.imageData = this.imageDoc[0];
              bannerCarouselImageViewModel.fileName = this.imageDoc[0].name.split('.');
              this.bannerCarouselImages.push(bannerCarouselImageViewModel);
              this.refreshBannerContentdata.emit();
              this.goBacktoBannerContent.emit(createBannerCarouselResponseObj);
            },
              error => {
                // do something
              });
        } else {
          this.cmnSer.emitMetadataCheck(true, this.bannerFunction);
          this.refreshBannerContentdata.emit();
          this.goBacktoBannerContent.emit(createBannerCarouselResponseObj);
        }
      },
        error => {

        });

  }

  cancel() {
    this.isSubmitted = false;
    this.goBacktoBannerContent.emit({ cancel: true });
    this.dataService.setBannerContent(undefined);
    this.cmnSer.uploadedImageURL = '';
    this.bannerFunction = GlobalConstants.CONTENT_PAGES;
  }

  // IIT2-4660
  checkExpiryDateTime() {    
    if (this.customExpiryDateResult && this.customExpiryDateResult !== GlobalConstants.NEVER) {
      this.isExpiredDateIncorrect = Utils.customDateCheck(this.customPublishDateResult, this.customExpiryDateResult);
    }
  }

  // IIT2-4660
  customValidation() {
    if (this.isPublishDateCustomDatepicker) {
      this.isCustomPublishDateCorrect = (this.customPublishDateResult === GlobalConstants.NOW);
    }
    if (this.isExpiryDatePicker) {
      this.isCustomExpiryDateCorrect = (this.customExpiryDateResult === GlobalConstants.NEVER);
    }
  }

  onAdd() {
    this.checkExpiryDateTime();
    this.customValidation();
    this.isFormValid = !this.isPublishedDateInCorrect && !this.isExpiredDateIncorrect &&
    !this.isCustomExpiryDateCorrect &&
    !this.isCustomPublishDateCorrect && this.bannerContentgrpForm?.controls?.publishedName?.value.trim() !== '' &&
    !this.isCustomPublishTimeZoneSelected && !this.isCustomExpiryTimeZoneSelected;
    if (this.isFormValid) {
      if (this.selectedBannerContentId) {
        this.updateBannerContent();
      } else {
        this.createBannerContent();
      }
      this.isSubmitted = true;
    }
  }

  getDuration(e) {
    this.imageDoc = e.target.files;
    const max_size = 10048576; // TODO: Move to constants
    this.imageFileType = this.imageDoc[0].type;
    this.imageFileName = this.imageDoc[0].name;
    this.imageFileSize = this.imageDoc[0].size;
    this.imageSizeError = this.imageFileSize > max_size;
    this.imageTypeError = (this.imageFileType !== GlobalConstants.FILE_TYPE_IMAGE);
    this.isImageAvailable = !(this.imageSizeError || this.imageTypeError || (this.imageSizeError && this.imageTypeError));
  }

  processFile(event) {
    this.imageDoc = event.target.files;
    if (this.imageDoc) {
      const reader = new FileReader();
      reader.readAsDataURL(this.imageDoc[0]);
      this.imageFileName = this.imageDoc[0].name;
      this.imageFileType = this.imageDoc[0].type;
      this.imageFileSize = this.imageDoc[0].size;
      this.media.uploadedDate = new Date();
      const fileType = this.imageDoc[0].type.split('/')[1];
      if (this.imageFileType.indexOf(GlobalConstants.FILE_TYPE_IMAGE) > -1) {
        this.imageSizeError = this.imageFileSize > GlobalConstants.UPLOAD_LOGO_IMAGE_SIZE_5MB;
        if (fileType === GlobalConstants.CONTENT_TYPE_PNG ||
          fileType === GlobalConstants.CONTENT_TYPE_GIF ||
          fileType === GlobalConstants.CONTENT_TYPE_JPEG) {
          this.imageTypeError = false;
          if (this.isRemoveEnabled || this.isImgVideoSizeInfoEnabled) {
            this.imageSizeError = false;
          }
        } else { this.imageTypeError = true; }
        this.isImageAvailable = !(this.imageSizeError || this.imageTypeError || (this.imageSizeError && this.imageTypeError));
        this.isImageFormat = true;
        this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.imageDoc[0]));
      } else {
        this.imageTypeError = true;
        this.isImageFormat = false;
        //this.imageUrl = '';
      }
      if (this.imageSizeError || this.imageTypeError) {
        this.imageUrl = '';
      } else {
        reader.onload = _event => {
          this.imageUrl = reader.result;
          this.emitImageDataToPreview(this.imageDoc[0]);
        };
      }
    }
  }

  emitImageDataToPreview(imageDoc) {
    this.bannerPreviewData.image.name = imageDoc ? imageDoc.name : '';
    this.bannerPreviewData.image.url = imageDoc ? this.imageUrl : '';
    this.bannerPreviewData.image.format = imageDoc ? imageDoc.type : '';
    this.bannerPreviewData.bgColor = this.bgColor ? this.bgColor : '';
    this.cmnSer.emitDataToLivePreview({ page: GlobalConstants.BANNER, dataSet: this.bannerPreviewData });
  }

  openModal(modal: any) {
    modal.open();
  }

  closeModal(modal: any) {
    modal.close();
  }

  openFormFactorsModal() {
    this.openModal(this.formFactorsModal);
  }
  applyFormFactor(updatedFormFactors) {
    this.selectedFormFactors = updatedFormFactors;
    this.closeModal(this.formFactorsModal);
  }

  // IIT2-4660-Start
  getLogoContentExpiryDate(data) {
    this.customExpiryDateResult = Utils.formatDate(data);
  }

  getLogoContentPublishDate(data) {
    this.customPublishDateResult = Utils.formatDate(data);
  }

  selectCustomPublishDate(datetimeOption) {
    this.isPublishDateCustomDatepicker = Utils.isCustomStatus(datetimeOption);
    if (!this.isPublishDateCustomDatepicker && this.customPublishDateResult !== GlobalConstants.NOW) {
      this.customPublishDateResult = Utils.getCurrentDate();
    }
    if (datetimeOption === GlobalConstants.NOW) {
      this.isCustomPublishDateCorrect = false;
      this.isCustomPublishTimeZoneSelected = false;
    }
  }

  checkIfTimeset(data, check) {
    if(data[0] && data[1]) {
      (check === 'publish') ? (this.isCustomPublishDateCorrect = false) : (this.isCustomExpiryDateCorrect = false);
    }
  }

  selectExpiryDateTimeZone(datetimeOption) {
    this.isExpiryDatePicker = Utils.isCustomStatus(datetimeOption);
    if(this.isExpiryDatePicker && this.editExpiryDateInfo) {
      this.customExpiryDateResult = this.editExpiryDateInfo;
    }
    if (!this.isExpiryDatePicker && this.customExpiryDateResult !== GlobalConstants.NEVER) {
      this.customExpiryDateResult = GlobalConstants.NEVER;
    }
    if (datetimeOption === GlobalConstants.NEVER) {
      this.isExpiredDateIncorrect = false;
      this.isCustomExpiryDateCorrect = false;
      this.isCustomExpiryTimeZoneSelected = false;
    }
  }
  // IIT2-4660-End

  checkTimeZone(data, check) {
    (check === GlobalConstants.PUBLISH) ? (this.isCustomPublishTimeZoneSelected = !data) : (this.isCustomExpiryTimeZoneSelected = !data);
  }
  emitPageDataToPreview() {
    this.cmnSer.emitDataToLivePreview({ page: GlobalConstants.BANNER, dataSet: {bgColor : this.bgColor} });
  }
}
